<template>
  <div>
     <el-dialog
      title="修改出库计划"
      :visible.sync="changePlanBillVisible"
      :close-on-click-modal="false"
      :before-close="addCancel"
      center
      width="80%"
    >
      <el-form :inline="true" label-width="90px" ref="addBillForm" class="demo-form-inline" :model="addBillForm" :rules="rules">
        <el-form-item label="一级货主:" prop="primaryCustomerTaxId">
          <el-select clearable v-model="addBillForm.primaryCustomerTaxId" disabled filterable placeholder="请选择" style="width:180px" size="mini">
            <el-option
              v-for="(item, index) in customerData"
              :key="index"
              :label="item.custerName"
              :value="item.taxpayerNumber"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="二级货主:" prop="secondaryCustomerTaxId">
          <el-select clearable v-model="addBillForm.secondaryCustomerTaxId" disabled filterable placeholder="请选择" style="width:180px" size="mini" >
            <el-option
              v-for="(item, index) in customerData"
              :key="index"
              :label="item.custerName"
              :value="item.taxpayerNumber"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客户单号:" prop="outBillNo">
         <el-input v-model="addBillForm.outBillNo" maxlength="50" placeholder="请输入客户单号" style="width:180px" size="mini"></el-input>
        </el-form-item>
        <el-form-item label="提货客户:" >
         <el-input v-model="addBillForm.pickupCustomerName" maxlength="30" placeholder="请输入提货客户" style="width:180px" size="mini"></el-input>
        </el-form-item>
         <el-form-item prop="remark" label="备注:">
          <el-input type="textarea" v-model="addBillForm.remark" maxlength="100" :rows="1" style="width:400px;"></el-input>
        </el-form-item>
      </el-form>
      <div >
        <p>人车信息</p>
        <hr>
        <el-table
          max-height="300px"
          border
          bordersize="mini"
          size="mini"
          ref="tabref"
          :data="subTableData"
          style="width:100%"
          highlight-current-row
          :header-cell-style="{background:'#F5F5F5',color:'black'}"
        >
          <el-table-column :show-overflow-tooltip="true" type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
          <el-table-column prop="plateNumber" label="提货车号">
            <template slot-scope="scope">
              <el-input v-if="!noBillId" size="mini" v-model="scope.row.plateNumber" placeholder="请输入提货车号" @blur="vhcInput(scope.row.plateNumber)"></el-input>
              <el-select v-else clearable  @change="plateNumChange(scope.row,scope.row.plateNumber)" v-model="scope.row.plateNumber" size="mini" placeholder="请选择">
                  <el-option
                    v-for="(item,index) in plateNumberOption"
                    :key="index"
                    :label="item.plateNumber"
                    :value="item.plateNumber"
                  ></el-option>
                </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="driverName" label="司机姓名" width="">
            <template slot-scope="scope">
              <el-input size="mini" :disabled='scope.row.disDriverName' v-model="scope.row.driverName" placeholder="请输入司机姓名"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="idNumber" label="司机身份证号">
            <template slot-scope="scope">
              <el-input size="mini" :disabled='scope.row.disIdNum' v-model="scope.row.idNumber" placeholder="请输入司机身份证号" @blur="idInput(scope.row.idNumber)"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="telephone" label="联系电话">
            <template slot-scope="scope">
              <el-input size="mini" :disabled='scope.row.disTelephone' v-model="scope.row.telephone" placeholder="请输入司机联系电话" @blur="phoneInput(scope.row.telephone)"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template v-slot="scope">
              <el-button type="text" :disabled='scope.row.disSelectSiji' @click="selectSiji(scope.row,scope.$index)">选择司机</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="margin:20px 0 30px 0;" v-for="(item,ix) in allDataList" :key="ix">
          <p>货物信息</p>
          <hr>
          <div>
            <div style="display: flex;justify-content: space-between;">
              <div style="display: flex;margin-bottom:10px;">
                <!-- <div>{{(item.cargoControlKey).replace(/,/g,"/")}}</div> -->
                <div style="display: flex;">
                  <!-- <span style="margin-left:20px;">总重量：</span> -->
                  <span style="margin-left:20px;">总件数：</span>
                  <div>
                    <!-- <span style="color:red">{{item.sumWeight}}</span><span> 吨 </span><span> / </span> -->
                    <span style="color:red">{{item.num}}</span><span> 件</span>
                  </div>
                </div>
                <div style="display: flex;" v-if="item.surplus">
                  <span style="margin-left:20px;">货权剩余：</span>
                  <div>
                    <!-- <span v-if='isEnableObj.controlWeight == 1'><span style="color:red">{{surplusControlWeight}}</span><span> 吨</span></span>
                    <span v-if='isEnableObj.controlPiece == 1'><span> / </span><span  style="color:red">{{surplusControlNumber}}</span><span> 件</span></span> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <el-table
            max-height="300px"
            border
            bordersize="mini"
            size="mini"
            ref="tabref"
            :data="item.tEmptyOutstockSummaryList"
            style="width:100%"
            highlight-current-row
            :header-cell-style="{background:'#F5F5F5',color:'black'}"
          >
          <el-table-column type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
          <el-table-column prop="placeOfOrigin" align="center" label="产地" width=""></el-table-column>
          <el-table-column prop="productTypeName" align="center" label="货物类型" width=""></el-table-column>
          <el-table-column prop="specification" align="center" label="规格" width=""></el-table-column>
          <el-table-column prop="model" align="center" label="材质"  width=""></el-table-column>
          <el-table-column prop="warehouseId" align="center" label="仓位" width="150">
            <template slot-scope="scope1">
                <el-select
                clearable
                  filterable
                  @change="changeCangWei(scope1.row,scope1.row.warehouseId)"
                  v-model="scope1.row.warehouseId"
                  size="mini"
                  :disabled="scope1.row.disCangWei"
                  placeholder="请选择仓位"
                >
                  <el-option
                    v-for="(item,index) in scope1.row.warehouseList"
                    :key="index"
                    :label="item.warehouseName"
                    :value="item.warehouseId"
                  ></el-option>
                </el-select>
              </template>
          </el-table-column>
          <el-table-column prop="number" align="center" label="件数" width="90">
            <template slot-scope="scope1">
              <el-input
                v-model="scope1.row.number"
                @blur="changeJianShu(scope1.row,scope1.row.number)"
                :disabled="scope1.row.disJianShu"
                v-number-input.float="0"
                maxlength="50"
                placeholder="请输入件数"
                size="mini"
              ></el-input>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="weight" align="center" label="总重量（吨）" width="">
            <template slot-scope="scope1">
              <el-input
                v-model="scope1.row.allWeight"
                maxlength="50"
                v-number-input.float="4"
                placeholder="请输入重量"
                size="mini"
                :disabled='scope1.row.disWeight'
                @blur="weightInput(scope1.row,scope1.row.allWeight)"
              ></el-input>
            </template>
          </el-table-column> -->
          <el-table-column prop="shipForecastId" align="center" label="预报编号" width="240">
            <template slot-scope="scope1">
                <el-select
                  clearable
                  filterable
                  @change="shipForecastChang(scope1.row,scope1.row.shipForecastId)"
                  v-model="scope1.row.shipForecastId"
                  size="mini"
                  placeholder="请选择预报编号"
                  style="width:230px;"
                >
                  <el-option
                    v-for="(item,index) in scope1.row.shipList"
                    :key="index"
                    :label="item.shipForecastNo"
                    :value="Number(item.shipForecastId)"
                  ></el-option>
                </el-select>
              </template>
          </el-table-column>
          <el-table-column prop="number" align="center" label="操作" width="70">
            <template slot-scope="scope1">
              <el-button @click="tabDelClick(item,scope1.$index)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        </div>
      <div slot="footer">
        <el-button type="" @click="addCancel">取消</el-button>
        <el-button type="primary" @click="changeSubmit" :loading='changeLoading'>保存</el-button>
      </div>
    </el-dialog>
    <select-siji v-if="selectSijiVisible" :table.sync="selectSijiVisible" @selectDriver="selectDriver"></select-siji>
  </div>
</template>

<script>
import {
  JfgetTEmptyBillDriverList, // 取得人车信息
  getRelationCustomer, // 字典客户
  JfvirtualControlBean, // 调用控货接口
  JfgetTEmptyStockCustomerGroup, // 货物类型、产地、材质等下拉框
  JfgetEmptyBillStockWarehouseInfo, // 添加计划货物信息 仓位下拉框 & 客户库存Id
  JfgetOutstockInfoJanFa, // 查询出库单主表子表所有信息（打印、修改回显、确认出库回显用）
  JfupdateWhOutstockMasterJanFa, // 修改保存
  JfdelTEmptyOutstockSummaryJanFa, // 删除货物信息
  getOutstockInfoJanFaForSummary,
  getTStockSummaryGroupForShip,
  getNewTStockSummary,
  updateEmptyOutstockJanFaForSummary
} from '@/api/wms-stock.js'
import SelectSiji from '../SelectSiji'

const vhsrule = /^([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[a-zA-Z](([DF]((?![IO])[a-zA-Z0-9](?![IO]))[0-9]{4})|([0-9]{5}[DF]))|[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1})$/
const idrule = /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/
const phonerule = /^[1]([3-9])[0-9]{9}$/

export default {
  components: { SelectSiji },
  name: 'XinzengTidan',
  data () {
    return {
      addBillForm: {
        primaryCustomerTaxId: '',
        secondaryCustomerTaxId: '',
        ownerCustomerTaxId: '',
        ownerCustomerName: '',
        outBillNo: '',
        pickupCustomerName: '',
        carHoldFalg: '',
        remark: '',
        billId: '', // 出库提单id
        outstockId: '' // 出库单id
      },
      customerData: [], // 货主数据
      rules: {
        primaryCustomerTaxId: [{ required: true, message: '请选择一级货主', trigger: 'change' }],
        secondaryCustomerTaxId: [{ required: true, message: '请选择二级货主', trigger: 'change' }]
      },
      subTableData: [],
      subTableDataB: [],
      subTableDataC: [],
      changeLoading: false,
      selectSijiVisible: false,
      TableIndex: 0,
      hasValidFlag: true,
      emptyBillType: '',
      billNo: '',
      allDataList: [],
      // isEnableObj: {},
      surplusControlWeight: 0,
      surplusControlNumber: 0,
      noBillId: false,
      plateNumberOption: [],
      tEmptyOutstockMaster: {},
      chePai: '',
      xiuGaiData: {},
      flagA: false
    }
  },
  props: {
    changePlanBillVisible: {
      type: Boolean,
      default: false
    },
    xztableData: {
      type: Array
    },
    xiugaiObj: {
      type: Object
    },
    outstockPlateNumber: {
      type: String,
      default: ''
    }
  },
  watch: {
    xztableData: {
      deep: true,
      immediate: true,
      handler (val) {
        if (val.length == 0) {
        } else {
        }
      }
    },
    xiugaiObj: {
      deep: true,
      immediate: true,
      handler (val) {
        if (val) {
          this.xiuGaiData = val
          this.addBillForm.outBillNo = val.outBillNo
          this.addBillForm.pickupCustomerName = val.pickupCustomerName
          this.addBillForm.primaryCustomerTaxId = val.primaryCustomerTaxId
          this.addBillForm.secondaryCustomerTaxId = val.customerTaxId
          this.addBillForm.remark = val.remark
          this.addBillForm.billId = val.billId
          this.addBillForm.outstockId = val.outstockId
          this.emptyBillType = val.emptyBillType
          this.billNo = val.billNo
          this.chePai = val.outstockPlateNumber
        }
      }
    }
  },
  mounted () {
    this.getRelationCustomer()
    this.addSiji()
    // this.getOutstockInfoJanFa()
    this.getOutstockInfoJanFaForSummary()
    // 2022.03.29 粤运仓沟通群提需求 去掉查询条件带过来的车牌号
    // if (this.outstockPlateNumber) {
    //   this.subTableData[0].plateNumber = this.outstockPlateNumber
    // } else {
    //   this.subTableData[0].plateNumber = this.chePai
    // }
  },
  methods: {
    addSiji () {
      let obj = {}
      obj.plateNumber = ''
      obj.driverName = ''
      obj.billDriverId = ''
      obj.idNumber = ''
      obj.telephone = ''
      obj.delFlag = ''
      obj.disPlateNum = false
      obj.disDriverName = false
      obj.disIdNum = false
      obj.disTelephone = false
      obj.disSelectSiji = false
      obj.disDeleteTable = false
      this.subTableData.push(obj)
    },
    tabDelClick (item, ix) {
      item.tEmptyOutstockSummaryList.forEach((item1, index1) => {
        if (index1 == ix) {
          this.$confirm('删除之后数据不能恢复，是否删除？', '提示', {
            confirmButtonText: '是',
            cancelButtonText: '否',
            closeOnClickModal: false,
            type: 'warning'
          }).then(() => {
            JfdelTEmptyOutstockSummaryJanFa({
              outstockSummaryId: item1.outstockSummaryId
            }).then(res => {
              this.$message.success('删除成功')
              if (item.tEmptyOutstockSummaryList.length == 0) {
                item.num = 0
                item.sumWeight = 0
              }
              this.getOutstockInfoJanFaForSummary()
            }).catch(err => {
              this.$message.error(err.message)
            })
          }).catch(() => {
          })
        }
      })
    },
    addCancel () {
      this.$emit('update:changePlanBillVisible', false)
      this.$parent.xztableData = []
      this.$parent.xiugaiObj = {}
    },
    selectSiji (row, index) {
      this.TableIndex = index
      this.selectSijiVisible = true
    },
    selectDriver (row) {
      this.$set(this.subTableData[this.TableIndex], 'driverName', row.name)
      this.$set(this.subTableData[this.TableIndex], 'telephone', row.mobile)
      this.$set(this.subTableData[this.TableIndex], 'idNumber', row.identityNo)
    },
    deleteTable (row, index) {
      this.subTableData.splice(index, 1)
      this.subTableDataB = []
      this.subTableDataB.push(row)
      this.subTableDataB.forEach((item) => {
        row.delFlag = '1'
      })
    },
    // 获取一级、二级客户
    getRelationCustomer () {
      getRelationCustomer().then(res => {
        this.customerData = res // 客户
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    vhcInput (val) {
      // if (!vhsrule.test(val)) {
      //   this.$message({ message: '请输入正确的车牌号', type: 'error' })
      // }
    },
    idInput (val) {
      if (val != '' && !idrule.test(val)) {
        this.$message({ message: '请输入正确的身份证号', type: 'error' })
      }
    },
    phoneInput (val) {
      if (val != '' && !phonerule.test(val)) {
        this.$message({ message: '请输入正确的手机号', type: 'error' })
      }
    },
    // 出库提单 取得人车信息
    getDriverList () {
      JfgetTEmptyBillDriverList({
        billId: this.tEmptyOutstockMaster.billId
      }).then(res => {
        res.forEach(item => {
          this.plateNumberOption.push(item)
          this.plateNumberOption.forEach(item => {
            if (this.subTableData[0].plateNumber == item.plateNumber) {
              this.subTableData[0].billDriverId = item.billDriverId
              this.subTableData[0].idNumber = item.idNumber
              this.subTableData[0].telephone = item.telephone
              this.subTableData[0].driverName = item.driverName
            }
          })
        })
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    plateNumChange (row, val) {
      if (val) {
        this.plateNumberOption.forEach((item) => {
          if (val == item.plateNumber) {
            this.subTableData[0].driverName = item.driverName
            this.subTableData[0].idNumber = item.idNumber
            this.subTableData[0].telephone = item.telephone
            this.subTableData[0].billDriverId = item.billDriverId
          }
        })
      } else {
        row.driverName = ''
        row.idNumber = ''
        row.telephone = ''
      }
    },
    changeCangWei (row, val) {
      this.$set(row, 'shipList', '')
      this.$set(row, 'shipForecastNo', '')
      this.$set(row, 'shipForecastId', '')
      console.log(row.shipForecastNo, 'shipForecastNo')
      console.log(row)
      row.warehouseList.forEach((item, index) => {
        if (val == item.warehouseId) {
          row.warehouseName = item.warehouseName
          getTStockSummaryGroupForShip({
            primaryCustomerTaxId: this.addBillForm.primaryCustomerTaxId, // （一级货主id 必填）
            customerTaxId: this.addBillForm.secondaryCustomerTaxId, // （二级货主id 必填）
            productType: row.productType, // （货物类型 必填）
            steelMillName: row.placeOfOrigin, // （产地 必填）
            model: row.model, // （材质 必填）
            specification: row.specification, // （规格 必填）
            warehouseId: val// （仓库id 必填）
          }).then(res => {
            this.$set(row, 'shipList', res)
          }).catch(err => {
            this.$message.error(err.message)
          })
        }
      })
    },
    shipForecastChang (row, val) {
      row.shipList.forEach((item, index) => {
        if (val == item.shipForecastId) {
          let shipForecastId
          if (val == '-1') {
            shipForecastId = null
          } else {
            shipForecastId = item.shipForecastId
          }
          row.shipForecastNo = item.shipForecastNo
          console.log(row.shipForecastNo, 'row.shipForecastNo')
          getNewTStockSummary({
            primaryCustomerTaxId: this.addBillForm.primaryCustomerTaxId, // （一级货主id 必填）
            customerTaxId: this.addBillForm.secondaryCustomerTaxId, // （二级货主id 必填）
            productType: row.productType, // （货物类型 必填）
            steelMillName: row.placeOfOrigin, // （产地 必填）
            model: row.model, // （材质 必填）
            specification: row.specification, // （规格 必填）
            warehouseId: row.warehouseId, // （仓库id 必填）
            shipForecastId: shipForecastId// （船运预报编号id 非必填）
          }).then(res => {
            this.$set(row, 'singletonWeight', res.singletonWeight)
            this.$set(row, 'stockAvailableNumber', res.stockAvailableNumber)
            this.$set(row, 'stockSummaryId', res.stockSummaryId)
            this.$set(row, 'stockWarehouseId', res.stockWarehouseId)
            this.$set(row, 'vehicleNumber', res.vehicleNumber)
            this.$set(row, 'weight', (row.number / 1 * row.singletonWeight).toFixed(4))
          }).catch(err => {
            this.$message.error(err.message)
          })
        }
      })
    },
    changeJianShu (row, val) {
      if (val) {
        // this.$set(row, 'allWeight', (row.number / 1 * row.singletonWeight).toFixed(4))
        this.$set(row, 'weight', (row.number / 1 * row.singletonWeight).toFixed(4))
      }
      this.allDataList.forEach((item, index) => {
        this.$set(item, 'num', item.tEmptyOutstockSummaryList.reduce((pre, cur) => { return pre / 1 + cur.number / 1 }, 0))
        // this.$set(item, 'sumWeight', (item.list.reduce((pre, cur) => { return pre / 1 + cur.allWeight / 1 }, 0)).toFixed(4))
      })
    },
    weightInput (val, row) {
      // console.log(row, val)
      // this.$set(val, 'allWeight', Number(row).toFixed(4))
    },
    changeSubmit () {
      this.$refs.addBillForm.validate((valid) => {
        if (valid) {
          // this.changeLoading = true
          // let chepai = this.subTableData.some(item => !vhsrule.test(item.plateNumber))
          let idCard = this.subTableData.some(item => !idrule.test(item.idNumber) && item.idNumber != '')
          let phoneCard = this.subTableData.some(item => !phonerule.test(item.telephone) && item.telephone != '')
          // if (chepai) {
          //   this.$message({ message: '车牌号不正确', type: 'error' })
          //   this.changeLoading = false
          //   return
          // } else
          if (idCard) {
            this.$message({ message: '身份证号不正确', type: 'error' })
            this.changeLoading = false
            return
          } else if (phoneCard) {
            this.$message({ message: '手机号不正确', type: 'error' })
            this.changeLoading = false
            return
          }
          this.addBillForm.primaryCustomerName = this.customerData.filter(item => item.taxpayerNumber == this.addBillForm.primaryCustomerTaxId)[0].custerName
          this.addBillForm.secondaryCustomerName = this.customerData.filter(item => item.taxpayerNumber == this.addBillForm.secondaryCustomerTaxId)[0].custerName
          let plateNumber = ''; let driverName = ''; let telephone = ''; let idNumber = ''
          plateNumber = this.subTableData.map(item => item.plateNumber).join(',')
          // 司机姓名
          let driverNameArr = this.subTableData.map(item => item.driverName)
          driverNameArr.forEach((item, index) => {
            if (item == '') { driverNameArr.splice(index, 1) }
          })
          driverName = driverNameArr.join(',')
          // 司机联系电话
          let telephoneArr = this.subTableData.map(item => item.telephone)
          telephoneArr.forEach((item, index) => {
            if (item == '') { telephoneArr.splice(index, 1) }
          })
          telephone = telephoneArr.join(',')
          // 司机身份证
          let idNumberArr = this.subTableData.map(item => item.idNumber)
          idNumberArr.forEach((item, index) => {
            if (item == '') { idNumberArr.splice(index, 1) }
          })
          idNumber = idNumberArr.join(',')
          console.log(this.allDataList)
          if (this.allDataList.length != 0) {
            for (let index = 0; index < this.allDataList[0].tEmptyOutstockSummaryList.length; index++) {
              if (this.allDataList[0].tEmptyOutstockSummaryList[index].shipForecastId == '-1') {
                this.allDataList[0].tEmptyOutstockSummaryList[index].shipForecastId = null
                this.allDataList[0].tEmptyOutstockSummaryList[index].shipForecastNo = '无'
              }
            }
          }
          // let arr = this.allDataList[0].tEmptyOutstockSummaryList
          // for (var i = 0; i < arr.length - 1; i++) {
          //   for (var j = i + 1; j < arr.length; j++) {
          //     if (arr[i].placeOfOrigin === arr[j].placeOfOrigin && arr[i].productType === arr[j].productType &&
          //        arr[i].specification === arr[j].specification && arr[i].model === arr[j].model &&
          //        arr[i].warehouseId === arr[j].warehouseId && arr[i].number === arr[j].number &&
          //        arr[i].shipForecastId === arr[j].shipForecastId) {
          //       console.log('重复了')
          //       this.flagA = false
          //     } else {
          //       this.flagA = true
          //       console.log('成功')
          //     }
          //   }
          // }
          let tEmptyOutstockMaster = {
            outstockId: this.addBillForm.outstockId, // （出库单id  必填）
            outBillNo: this.addBillForm.outBillNo, // （货主单号 非必填）
            pickupCustomerName: this.addBillForm.pickupCustomerName, // （货主单号 非必填）
            remark: this.addBillForm.remark, // （出库单备注 非必填）
            // billDriverId: '', // （提单司机id 有提单id的必填）
            outstockPlateNumber: plateNumber, // （出库车牌号  必填）
            driverName: driverName, // （司机姓名  非必填）
            telephone: telephone, // （司机手机 非必填）
            idNumber: idNumber // （身份证号 非必填）
          }
          if (this.noBillId == true) {
            this.$set(tEmptyOutstockMaster, 'billDriverId', this.subTableData[0].billDriverId)
          }
          if (this.allDataList.length == 0) {
            this.$message.error('请关联货物信息')
          } else {
            let flagB = this.allDataList[0].tEmptyOutstockSummaryList.every(item => item.shipForecastId != '')
            console.log(flagB, 'flagB')
            if (!flagB) {
              this.$message.error('预报编号不能为空')
              return
            }
            if (flagB) {
              updateEmptyOutstockJanFaForSummary({
                tEmptyOutstockMaster: tEmptyOutstockMaster,
                tEmptyOutstockSummaryList: this.allDataList[0].tEmptyOutstockSummaryList
              }).then(res => {
                this.changeLoading = false
                this.$emit('update:changePlanBillVisible', false)
                this.$message.success('修改成功')
                this.$parent.chaxun()
              }).catch(err => {
                this.changeLoading = false
                this.$message.error(err.message)
              })
            }
          }
        } else {
          this.changeLoading = false
        }
      })
    },
    // 修改获取数据
    getOutstockInfoJanFaForSummary () {
      getOutstockInfoJanFaForSummary({
        outstockId: this.addBillForm.outstockId
      }).then(res => {
        console.log(res)
        this.tEmptyOutstockMaster = res.tEmptyOutstockMaster
        if (res.tEmptyOutstockMaster.billId != null) {
          this.noBillId = true
          this.getDriverList()
          // if (this.xiuGaiData.ext1 == '1') {
          this.subTableData[0].plateNumber = res.tEmptyOutstockMaster.outstockPlateNumber
          this.subTableData[0].driverName = res.tEmptyOutstockMaster.driverName
          this.subTableData[0].idNumber = res.tEmptyOutstockMaster.idNumber
          this.subTableData[0].telephone = res.tEmptyOutstockMaster.telephone
          // }
        } else {
          this.noBillId = false
          this.subTableData[0].plateNumber = res.tEmptyOutstockMaster.outstockPlateNumber
          this.subTableData[0].driverName = res.tEmptyOutstockMaster.driverName
          this.subTableData[0].idNumber = res.tEmptyOutstockMaster.idNumber
          this.subTableData[0].telephone = res.tEmptyOutstockMaster.telephone
        }
        let tEmptyOutstockSummaryList = res.tEmptyOutstockSummaryList
        if (tEmptyOutstockSummaryList.length != 0) {
          let mapData = new Map()
          for (const item of tEmptyOutstockSummaryList) {
            let cargoControlKey = item.tEmptyOutstockSummary.cargoControlKey
            if (cargoControlKey == ',,,') {
              cargoControlKey = '总控'
            }
            item.tEmptyOutstockSummary.flag = item.flag
            item.tEmptyOutstockSummary.outPoundMethodName = item.outPoundMethodName
            if (mapData.has(cargoControlKey)) {
              let dataObj = mapData.get(cargoControlKey)
              dataObj.sumWeight = Math.round((dataObj.sumWeight + item.tEmptyOutstockSummary.allWeight) * 1000) / 1000
              dataObj.num = dataObj.num + item.tEmptyOutstockSummary.number
              this.$set(item.tEmptyOutstockSummary, 'warehouseList', item.warehouseList)
              this.$set(item.tEmptyOutstockSummary, 'shipList', item.shipList)
              if (item.tEmptyOutstockSummary.shipForecastId == null) {
                item.tEmptyOutstockSummary.shipForecastId = -1
              }
              dataObj.tEmptyOutstockSummaryList.push(item.tEmptyOutstockSummary)
            } else {
              let dataObj = {
                cargoControlKey: cargoControlKey,
                tEmptyOutstockSummaryList: [],
                sumWeight: 0,
                num: 0
              }
              this.$set(item.tEmptyOutstockSummary, 'warehouseList', item.warehouseList)
              this.$set(item.tEmptyOutstockSummary, 'shipList', item.shipList)
              if (item.tEmptyOutstockSummary.shipForecastId == null) {
                item.tEmptyOutstockSummary.shipForecastId = -1
              }
              dataObj.tEmptyOutstockSummaryList.push(item.tEmptyOutstockSummary)
              dataObj.sumWeight = Math.round((dataObj.sumWeight + item.tEmptyOutstockSummary.allWeight) * 1000) / 1000
              dataObj.num = item.tEmptyOutstockSummary.number
              mapData.set(cargoControlKey, dataObj)
            }
          }
          this.allDataList = Array.from(mapData.values())
        } else {
          this.allDataList = []
        }
      }).catch(err => {
        this.$message({ message: err.message, type: 'error' })
      })
    }
  }
}
</script>

<style>

</style>
